import { Link } from "react-router-dom";
import AumChime from "@/components/AumChime";
import VisitCounter from "@/components/VisitCounter";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E5E5] bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif text-3xl text-[#1A1F24]">
            Gemma <span className="italic text-[#C5A059]">Veda</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-[#5C6670] max-w-xs">
            New-age author of the Soul's CODE series. Stories drawn from experience, culture and ancient wisdom.
          </p>
        </div>
        <div>
          <div className="gv-label mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-[#1A1F24]">
            <li><Link to="/books" className="gv-link" data-testid="footer-link-books">Books</Link></li>
            <li><Link to="/journal" className="gv-link" data-testid="footer-link-journal">Journal</Link></li>
            <li><Link to="/contact" className="gv-link" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="gv-label mb-4">Correspondence</div>
          <p className="text-sm text-[#5C6670]">For press, events & letters from readers — visit the <Link to="/contact" className="gv-link">contact page</Link>.</p>
          <div className="mt-6" data-testid="footer-newsletter">
            <div className="text-xs tracking-[0.22em] uppercase text-[#1A1F24] mb-2">Sign up for newsletter</div>
            <p className="text-xs text-[#5C6670] mb-3 max-w-xs">Be first to know when a new journal entry or book arrives.</p>
            <NewsletterSignup />
          </div>
        </div>
      </div>
      <div className="border-t border-[#E5E5E5] bg-gradient-to-b from-white to-[#FAFAFA] py-10 flex items-center justify-center">
        <AumChime />
      </div>
      <div className="border-t border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs tracking-[0.2em] uppercase text-[#5C6670]">
          <span>© {new Date().getFullYear()} Gemma Veda</span>
          <VisitCounter />
        </div>
      </div>
    </footer>
  );
}
